import * as t from "io-ts";
import * as E from "fp-ts/lib/Either";
import { DocumentWithCategoryC as imported20_DocumentWithCategoryC, DocumentWithCategory as imported20_DocumentWithCategory, documentWithCategoryC as imported20_documentWithCategoryC } from "./document";
import { LocalDateTimeFromIsoStringC } from "../../codecs/localDate";
import { ContactFormSubmissionC as imported18_ContactFormSubmissionC, ContactFormSubmission as imported18_ContactFormSubmission, contactFormSubmissionC as imported18_contactFormSubmissionC } from "./contact";
import * as O from "fp-ts/lib/Option";
import { LocalDateTime } from "@js-joda/core";
import { EitherC, either } from "io-ts-types/lib/either";
import { RfpC as imported65_RfpC, RfpC as imported63_RfpC, rfpC as imported59_rfpC, Rfp as imported61_Rfp, RfpC as imported62_RfpC, rfpC as imported60_rfpC, Rfp as imported64_Rfp, rfpC as imported58_rfpC, RfpC as imported60_RfpC, rfpC as imported57_rfpC, Rfp as imported65_Rfp, Rfp as imported60_Rfp, Rfp as imported62_Rfp, RfpC as imported64_RfpC, RfpC as imported61_RfpC, rfpC as imported62_rfpC, Rfp as imported63_Rfp, rfpC as imported61_rfpC } from "./rfpBase";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";
import * as RNEA from "fp-ts/lib/ReadonlyNonEmptyArray";
import { BondOfferingDetailsC as imported28_BondOfferingDetailsC, BondOfferingDetailsC as imported30_BondOfferingDetailsC, bondOfferingDetailsC as imported31_bondOfferingDetailsC, BondOfferingDetails as imported29_BondOfferingDetails, BondOfferingDetails as imported32_BondOfferingDetails, BondOfferingDetailsC as imported29_BondOfferingDetailsC, BondOfferingDetails as imported30_BondOfferingDetails, bondOfferingDetailsC as imported32_bondOfferingDetailsC, BondOfferingDetails as imported28_BondOfferingDetails, bondOfferingDetailsC as imported27_bondOfferingDetailsC, bondOfferingDetailsC as imported28_bondOfferingDetailsC, BondOfferingDetails as imported31_BondOfferingDetails, bondOfferingDetailsC as imported30_bondOfferingDetailsC, BondOfferingDetailsC as imported32_BondOfferingDetailsC, BondOfferingDetailsC as imported27_BondOfferingDetailsC, bondOfferingDetailsC as imported29_bondOfferingDetailsC, BondOfferingDetailsC as imported31_BondOfferingDetailsC, BondOfferingDetails as imported27_BondOfferingDetails } from "./bondOffering";
import { withModInfoC as imported228_withModInfoC, WithId as imported252_WithId, WithModInfo as imported226_WithModInfo, WithModInfoC as imported228_WithModInfoC, WithModInfo as imported228_WithModInfo, WithModInfoC as imported230_WithModInfoC, withModInfoC as imported226_withModInfoC, withIdC as imported245_withIdC, withIdC as imported253_withIdC, WithModInfo as imported234_WithModInfo, WithId as imported251_WithId, withIdC as imported250_withIdC, WithIdC as imported246_WithIdC, WithIdC as imported253_WithIdC, WithId as imported248_WithId, WithIdC as imported243_WithIdC, WithModInfoC as imported235_WithModInfoC, WithId as imported245_WithId, withIdC as imported243_withIdC, withModInfoC as imported230_withModInfoC, WithModInfoC as imported234_WithModInfoC, withModInfoC as imported232_withModInfoC, WithModInfoC as imported229_WithModInfoC, WithModInfoC as imported227_WithModInfoC, withIdC as imported265_withIdC, WithId as imported249_WithId, withIdC as imported255_withIdC, WithIdC as imported249_WithIdC, WithIdC as imported254_WithIdC, WithModInfoC as imported233_WithModInfoC, WithId as imported254_WithId, WithId as imported253_WithId, WithId as imported255_WithId, withModInfoC as imported236_withModInfoC, WithIdC as imported251_WithIdC, WithModInfoC as imported226_WithModInfoC, WithModInfo as imported233_WithModInfo, WithModInfo as imported229_WithModInfo, withModInfoC as imported227_withModInfoC, withIdC as imported252_withIdC, WithModInfo as imported236_WithModInfo, WithIdC as imported247_WithIdC, WithIdC as imported252_WithIdC, withIdC as imported246_withIdC, withModInfoC as imported235_withModInfoC, withModInfoC as imported233_withModInfoC, WithIdC as imported255_WithIdC, withIdC as imported251_withIdC, WithModInfoC as imported231_WithModInfoC, WithModInfoC as imported232_WithModInfoC, WithIdC as imported245_WithIdC, withIdC as imported254_withIdC, WithId as imported243_WithId, withModInfoC as imported229_withModInfoC, WithIdC as imported250_WithIdC, WithIdC as imported265_WithIdC, WithModInfo as imported230_WithModInfo, WithIdC as imported248_WithIdC, withModInfoC as imported231_withModInfoC, WithModInfoC as imported225_WithModInfoC, withIdC as imported249_withIdC, WithId as imported265_WithId, WithId as imported244_WithId, WithId as imported250_WithId, WithModInfo as imported225_WithModInfo, withModInfoC as imported225_withModInfoC, WithModInfoC as imported236_WithModInfoC, WithId as imported247_WithId, WithModInfo as imported235_WithModInfo, withModInfoC as imported234_withModInfoC, withIdC as imported244_withIdC, WithModInfo as imported232_WithModInfo, WithModInfo as imported231_WithModInfo, WithIdC as imported244_WithIdC, WithId as imported246_WithId, withIdC as imported247_withIdC, withIdC as imported248_withIdC, WithModInfo as imported227_WithModInfo } from "./threadThrough";
import { EmptyObjectC as imported0_EmptyObjectC, EmptyObject as imported0_EmptyObject, emptyObjectC as imported0_emptyObjectC } from "./emptyObject";
import { IpreoHoldingsC as imported12_IpreoHoldingsC, IpreoHoldings as imported12_IpreoHoldings, ipreoHoldingsC as imported12_ipreoHoldingsC } from "./ipreoHoldings";
import { ReadonlyNonEmptyArrayType, readonlyNonEmptyArrayC } from "../../codecs/readonlyNonEmptyArray";
import { TheseC, theseC } from "../../codecs/these";
import { DetailsC as imported95_DetailsC, DetailsC as imported99_DetailsC, Details as imported99_Details, tabCountC as imported9_tabCountC, detailsC as imported94_detailsC, DetailsC as imported101_DetailsC, detailsC as imported103_detailsC, detailsC as imported100_detailsC, tabCountC as imported12_tabCountC, DetailsC as imported102_DetailsC, DetailsC as imported100_DetailsC, DetailsC as imported103_DetailsC, detailsC as imported101_detailsC, detailsC as imported96_detailsC, Details as imported98_Details, Details as imported103_Details, tabCountC as imported10_tabCountC, DetailsC as imported98_DetailsC, detailsC as imported97_detailsC, detailsC as imported95_detailsC, TabCountC as imported9_TabCountC, detailsC as imported99_detailsC, Details as imported101_Details, DetailsC as imported96_DetailsC, TabCount as imported12_TabCount, Details as imported95_Details, detailsC as imported98_detailsC, TabCountC as imported11_TabCountC, TabCount as imported11_TabCount, tabCountC as imported11_tabCountC, Details as imported100_Details, detailsC as imported102_detailsC, Details as imported94_Details, Details as imported96_Details, TabCount as imported10_TabCount, Details as imported102_Details, TabCountC as imported12_TabCountC, DetailsC as imported94_DetailsC, TabCount as imported9_TabCount, TabCountC as imported10_TabCountC, Details as imported97_Details, DetailsC as imported97_DetailsC } from "./baseInvestorActivity";
import { ReadonlyMapFromEntriesC, readonlyMapFromEntries } from "io-ts-types/lib/readonlyMapFromEntries";
import { Ord as numberOrd } from "fp-ts/lib/number";
import { ActorC as imported7_ActorC, Actor as imported6_Actor, actorC as imported7_actorC, actorC as imported6_actorC, Actor as imported7_Actor, ActorC as imported6_ActorC } from "./actor";
import * as Th from "fp-ts/lib/These";
import { MarkdownC, Markdown, markdownC } from "../../codecs/markdown";

export type DocMetaC = t.TypeC<{
  issuerId: t.NumberC,
  rfpOrOfferingData: OptionFromNullableC<EitherC<imported245_WithIdC<imported227_WithModInfoC<imported61_RfpC>>, imported246_WithIdC<imported228_WithModInfoC<imported28_BondOfferingDetailsC>>>>
}>;
export type DocMeta = {
  issuerId: number,
  rfpOrOfferingData: O.Option<E.Either<imported245_WithId<imported227_WithModInfo<imported61_Rfp>>, imported246_WithId<imported228_WithModInfo<imported28_BondOfferingDetails>>>>
};
export const docMetaC: DocMetaC = t.type({
  issuerId: t.number,
  rfpOrOfferingData: optionFromNullable(either(imported245_withIdC(imported227_withModInfoC(imported58_rfpC)), imported246_withIdC(imported228_withModInfoC(imported28_bondOfferingDetailsC))))
}) satisfies t.Type<DocMeta, unknown>;


export type DocumentC = t.TypeC<{
  id: t.NumberC,
  title: t.StringC,
  meta: DocMetaC
}>;
export type Document = {
  id: number,
  title: string,
  meta: DocMeta
};
export const documentC: DocumentC = t.type({
  id: t.number,
  title: t.string,
  meta: docMetaC
}) satisfies t.Type<Document, unknown>;


export type EmailMetaC = t.TypeC<{
  emailCampaignId: OptionFromNullableC<t.NumberC>,
  issuerId: OptionFromNullableC<t.NumberC>,
  rfpOrOfferingData: OptionFromNullableC<EitherC<imported247_WithIdC<imported229_WithModInfoC<imported62_RfpC>>, imported248_WithIdC<imported230_WithModInfoC<imported29_BondOfferingDetailsC>>>>
}>;
export type EmailMeta = {
  emailCampaignId: O.Option<number>,
  issuerId: O.Option<number>,
  rfpOrOfferingData: O.Option<E.Either<imported247_WithId<imported229_WithModInfo<imported62_Rfp>>, imported248_WithId<imported230_WithModInfo<imported29_BondOfferingDetails>>>>
};
export const emailMetaC: EmailMetaC = t.type({
  emailCampaignId: optionFromNullable(t.number),
  issuerId: optionFromNullable(t.number),
  rfpOrOfferingData: optionFromNullable(either(imported247_withIdC(imported229_withModInfoC(imported59_rfpC)), imported248_withIdC(imported230_withModInfoC(imported29_bondOfferingDetailsC))))
}) satisfies t.Type<EmailMeta, unknown>;


export type EmailC = t.TypeC<{
  subject: t.StringC,
  meta: EmailMetaC
}>;
export type Email = {
  subject: string,
  meta: EmailMeta
};
export const emailC: EmailC = t.type({
  subject: t.string,
  meta: emailMetaC
}) satisfies t.Type<Email, unknown>;


export type RoadShowMetaC = t.TypeC<{
  issuerId: t.NumberC,
  rfpOrOfferingData: TheseC<ReadonlyNonEmptyArrayType<imported251_WithIdC<imported233_WithModInfoC<imported64_RfpC>>>, ReadonlyNonEmptyArrayType<imported252_WithIdC<imported234_WithModInfoC<imported31_BondOfferingDetailsC>>>>
}>;
export type RoadShowMeta = {
  issuerId: number,
  rfpOrOfferingData: Th.These<RNEA.ReadonlyNonEmptyArray<imported251_WithId<imported233_WithModInfo<imported64_Rfp>>>, RNEA.ReadonlyNonEmptyArray<imported252_WithId<imported234_WithModInfo<imported31_BondOfferingDetails>>>>
};
export const roadShowMetaC: RoadShowMetaC = t.type({
  issuerId: t.number,
  rfpOrOfferingData: theseC(readonlyNonEmptyArrayC(imported251_withIdC(imported233_withModInfoC(imported61_rfpC))), readonlyNonEmptyArrayC(imported252_withIdC(imported234_withModInfoC(imported31_bondOfferingDetailsC))))
}) satisfies t.Type<RoadShowMeta, unknown>;


export type RoadShowC = t.TypeC<{
  title: t.StringC,
  meta: RoadShowMetaC
}>;
export type RoadShow = {
  title: string,
  meta: RoadShowMeta
};
export const roadShowC: RoadShowC = t.type({
  title: t.string,
  meta: roadShowMetaC
}) satisfies t.Type<RoadShow, unknown>;


export type LinkMetaC = t.TypeC<{
  issuerId: t.NumberC,
  rfpOrOfferingData: EitherC<imported249_WithIdC<imported231_WithModInfoC<imported63_RfpC>>, imported250_WithIdC<imported232_WithModInfoC<imported30_BondOfferingDetailsC>>>
}>;
export type LinkMeta = {
  issuerId: number,
  rfpOrOfferingData: E.Either<imported249_WithId<imported231_WithModInfo<imported63_Rfp>>, imported250_WithId<imported232_WithModInfo<imported30_BondOfferingDetails>>>
};
export const linkMetaC: LinkMetaC = t.type({
  issuerId: t.number,
  rfpOrOfferingData: either(imported249_withIdC(imported231_withModInfoC(imported60_rfpC)), imported250_withIdC(imported232_withModInfoC(imported30_bondOfferingDetailsC)))
}) satisfies t.Type<LinkMeta, unknown>;


export type LinkC = t.TypeC<{
  name: t.StringC,
  description: OptionFromNullableC<MarkdownC>,
  meta: LinkMetaC
}>;
export type Link = {
  name: string,
  description: O.Option<Markdown>,
  meta: LinkMeta
};
export const linkC: LinkC = t.type({
  name: t.string,
  description: optionFromNullable(markdownC),
  meta: linkMetaC
}) satisfies t.Type<Link, unknown>;


export type ContactMetaC = t.TypeC<{
  issuerId: t.NumberC,
  rfpOrOfferingData: EitherC<imported243_WithIdC<imported225_WithModInfoC<imported60_RfpC>>, imported244_WithIdC<imported226_WithModInfoC<imported27_BondOfferingDetailsC>>>
}>;
export type ContactMeta = {
  issuerId: number,
  rfpOrOfferingData: E.Either<imported243_WithId<imported225_WithModInfo<imported60_Rfp>>, imported244_WithId<imported226_WithModInfo<imported27_BondOfferingDetails>>>
};
export const contactMetaC: ContactMetaC = t.type({
  issuerId: t.number,
  rfpOrOfferingData: either(imported243_withIdC(imported225_withModInfoC(imported57_rfpC)), imported244_withIdC(imported226_withModInfoC(imported27_bondOfferingDetailsC)))
}) satisfies t.Type<ContactMeta, unknown>;


export type OfferingViewedC = t.TypeC<{
  _tag: t.LiteralC<`OfferingViewed`>,
  details: imported94_DetailsC,
  offering: imported253_WithIdC<imported235_WithModInfoC<imported32_BondOfferingDetailsC>>
}>;
export type OfferingViewed = {
  _tag: `OfferingViewed`,
  details: imported94_Details,
  offering: imported253_WithId<imported235_WithModInfo<imported32_BondOfferingDetails>>
};
export const offeringViewedC: OfferingViewedC = t.type({
  _tag: t.literal(`OfferingViewed`),
  details: imported94_detailsC,
  offering: imported253_withIdC(imported235_withModInfoC(imported32_bondOfferingDetailsC))
}) satisfies t.Type<OfferingViewed, unknown>;


export type RfpViewedC = t.TypeC<{
  _tag: t.LiteralC<`RfpViewed`>,
  details: imported95_DetailsC,
  rfp: imported254_WithIdC<imported236_WithModInfoC<imported65_RfpC>>
}>;
export type RfpViewed = {
  _tag: `RfpViewed`,
  details: imported95_Details,
  rfp: imported254_WithId<imported236_WithModInfo<imported65_Rfp>>
};
export const rfpViewedC: RfpViewedC = t.type({
  _tag: t.literal(`RfpViewed`),
  details: imported95_detailsC,
  rfp: imported254_withIdC(imported236_withModInfoC(imported62_rfpC))
}) satisfies t.Type<RfpViewed, unknown>;


export type ContactFormSubmittedC = t.TypeC<{
  _tag: t.LiteralC<`ContactFormSubmitted`>,
  details: imported96_DetailsC,
  submissionInfo: imported255_WithIdC<imported18_ContactFormSubmissionC>,
  meta: ContactMetaC
}>;
export type ContactFormSubmitted = {
  _tag: `ContactFormSubmitted`,
  details: imported96_Details,
  submissionInfo: imported255_WithId<imported18_ContactFormSubmission>,
  meta: ContactMeta
};
export const contactFormSubmittedC: ContactFormSubmittedC = t.type({
  _tag: t.literal(`ContactFormSubmitted`),
  details: imported96_detailsC,
  submissionInfo: imported255_withIdC(imported18_contactFormSubmissionC),
  meta: contactMetaC
}) satisfies t.Type<ContactFormSubmitted, unknown>;


export type RoadShowViewedC = t.TypeC<{
  _tag: t.LiteralC<`RoadShowViewed`>,
  details: imported97_DetailsC,
  roadShow: RoadShowC,
  furthestSeek: OptionFromNullableC<t.NumberC>
}>;
export type RoadShowViewed = {
  _tag: `RoadShowViewed`,
  details: imported97_Details,
  roadShow: RoadShow,
  furthestSeek: O.Option<number>
};
export const roadShowViewedC: RoadShowViewedC = t.type({
  _tag: t.literal(`RoadShowViewed`),
  details: imported97_detailsC,
  roadShow: roadShowC,
  furthestSeek: optionFromNullable(t.number)
}) satisfies t.Type<RoadShowViewed, unknown>;


export type LinkClickedC = t.TypeC<{
  _tag: t.LiteralC<`LinkClicked`>,
  details: imported98_DetailsC,
  link: LinkC
}>;
export type LinkClicked = {
  _tag: `LinkClicked`,
  details: imported98_Details,
  link: Link
};
export const linkClickedC: LinkClickedC = t.type({
  _tag: t.literal(`LinkClicked`),
  details: imported98_detailsC,
  link: linkC
}) satisfies t.Type<LinkClicked, unknown>;


export type EmailOpenedC = t.TypeC<{
  _tag: t.LiteralC<`EmailOpened`>,
  details: imported99_DetailsC,
  email: EmailC,
  receivedDate: LocalDateTimeFromIsoStringC
}>;
export type EmailOpened = {
  _tag: `EmailOpened`,
  details: imported99_Details,
  email: Email,
  receivedDate: LocalDateTime
};
export const emailOpenedC: EmailOpenedC = t.type({
  _tag: t.literal(`EmailOpened`),
  details: imported99_detailsC,
  email: emailC,
  receivedDate: LocalDateTimeFromIsoStringC
}) satisfies t.Type<EmailOpened, unknown>;


export type EmailLinkClickedC = t.TypeC<{
  _tag: t.LiteralC<`EmailLinkClicked`>,
  details: imported100_DetailsC,
  email: EmailC,
  receivedDate: LocalDateTimeFromIsoStringC
}>;
export type EmailLinkClicked = {
  _tag: `EmailLinkClicked`,
  details: imported100_Details,
  email: Email,
  receivedDate: LocalDateTime
};
export const emailLinkClickedC: EmailLinkClickedC = t.type({
  _tag: t.literal(`EmailLinkClicked`),
  details: imported100_detailsC,
  email: emailC,
  receivedDate: LocalDateTimeFromIsoStringC
}) satisfies t.Type<EmailLinkClicked, unknown>;


export type EmailReceivedC = t.TypeC<{
  _tag: t.LiteralC<`EmailReceived`>,
  details: imported101_DetailsC,
  email: EmailC
}>;
export type EmailReceived = {
  _tag: `EmailReceived`,
  details: imported101_Details,
  email: Email
};
export const emailReceivedC: EmailReceivedC = t.type({
  _tag: t.literal(`EmailReceived`),
  details: imported101_detailsC,
  email: emailC
}) satisfies t.Type<EmailReceived, unknown>;


export type DocumentDownloadedC = t.TypeC<{
  _tag: t.LiteralC<`DocumentDownloaded`>,
  details: imported102_DetailsC,
  document: DocumentC
}>;
export type DocumentDownloaded = {
  _tag: `DocumentDownloaded`,
  details: imported102_Details,
  document: Document
};
export const documentDownloadedC: DocumentDownloadedC = t.type({
  _tag: t.literal(`DocumentDownloaded`),
  details: imported102_detailsC,
  document: documentC
}) satisfies t.Type<DocumentDownloaded, unknown>;


export type DocumentViewedC = t.TypeC<{
  _tag: t.LiteralC<`DocumentViewed`>,
  details: imported103_DetailsC,
  document: DocumentC
}>;
export type DocumentViewed = {
  _tag: `DocumentViewed`,
  details: imported103_Details,
  document: Document
};
export const documentViewedC: DocumentViewedC = t.type({
  _tag: t.literal(`DocumentViewed`),
  details: imported103_detailsC,
  document: documentC
}) satisfies t.Type<DocumentViewed, unknown>;


export const allInvestorActivityTabC = [offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, emailOpenedC, emailLinkClickedC, emailReceivedC, documentDownloadedC, documentViewedC] as const;
export const allInvestorActivityTabNames = [`OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `LinkClicked`, `EmailOpened`, `EmailLinkClicked`, `EmailReceived`, `DocumentDownloaded`, `DocumentViewed`] as const;
export type InvestorActivityTabName = (typeof allInvestorActivityTabNames)[number];

export type InvestorActivityTabCU = t.UnionC<[OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, LinkClickedC, EmailOpenedC, EmailLinkClickedC, EmailReceivedC, DocumentDownloadedC, DocumentViewedC]>;
export type InvestorActivityTabU = OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | LinkClicked | EmailOpened | EmailLinkClicked | EmailReceived | DocumentDownloaded | DocumentViewed;
export const InvestorActivityTabCU: InvestorActivityTabCU = t.union([offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, emailOpenedC, emailLinkClickedC, emailReceivedC, documentDownloadedC, documentViewedC]) satisfies t.Type<InvestorActivityTabU, unknown>;

export type InvestorActivityTabMap<A> = { [K in InvestorActivityTabName]: A };


export const allSiteActivityC = [offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC] as const;
export const allSiteActivityNames = [`OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `LinkClicked`] as const;
export type SiteActivityName = (typeof allSiteActivityNames)[number];

export type SiteActivityCU = t.UnionC<[OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, LinkClickedC]>;
export type SiteActivityU = OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | LinkClicked;
export const SiteActivityCU: SiteActivityCU = t.union([offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC]) satisfies t.Type<SiteActivityU, unknown>;

export type SiteActivityMap<A> = { [K in SiteActivityName]: A };


export const allEmailActivityC = [emailOpenedC, emailLinkClickedC, emailReceivedC] as const;
export const allEmailActivityNames = [`EmailOpened`, `EmailLinkClicked`, `EmailReceived`] as const;
export type EmailActivityName = (typeof allEmailActivityNames)[number];

export type EmailActivityCU = t.UnionC<[EmailOpenedC, EmailLinkClickedC, EmailReceivedC]>;
export type EmailActivityU = EmailOpened | EmailLinkClicked | EmailReceived;
export const EmailActivityCU: EmailActivityCU = t.union([emailOpenedC, emailLinkClickedC, emailReceivedC]) satisfies t.Type<EmailActivityU, unknown>;

export type EmailActivityMap<A> = { [K in EmailActivityName]: A };


export const allDocumentActivityC = [documentDownloadedC, documentViewedC] as const;
export const allDocumentActivityNames = [`DocumentDownloaded`, `DocumentViewed`] as const;
export type DocumentActivityName = (typeof allDocumentActivityNames)[number];

export type DocumentActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC]>;
export type DocumentActivityU = DocumentDownloaded | DocumentViewed;
export const DocumentActivityCU: DocumentActivityCU = t.union([documentDownloadedC, documentViewedC]) satisfies t.Type<DocumentActivityU, unknown>;

export type DocumentActivityMap<A> = { [K in DocumentActivityName]: A };


export const allInvestorActivityC = [documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, emailReceivedC] as const;
export const allInvestorActivityNames = [`DocumentDownloaded`, `DocumentViewed`, `OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `EmailOpened`, `EmailLinkClicked`, `LinkClicked`, `EmailReceived`] as const;
export type InvestorActivityName = (typeof allInvestorActivityNames)[number];

export type InvestorActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC, OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, EmailOpenedC, EmailLinkClickedC, LinkClickedC, EmailReceivedC]>;
export type InvestorActivityU = DocumentDownloaded | DocumentViewed | OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | EmailOpened | EmailLinkClicked | LinkClicked | EmailReceived;
export const InvestorActivityCU: InvestorActivityCU = t.union([documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, emailReceivedC]) satisfies t.Type<InvestorActivityU, unknown>;

export type InvestorActivityMap<A> = { [K in InvestorActivityName]: A };


export const allNonEmailSendActivityC = [documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC] as const;
export const allNonEmailSendActivityNames = [`DocumentDownloaded`, `DocumentViewed`, `OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `EmailOpened`, `EmailLinkClicked`, `LinkClicked`] as const;
export type NonEmailSendActivityName = (typeof allNonEmailSendActivityNames)[number];

export type NonEmailSendActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC, OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, EmailOpenedC, EmailLinkClickedC, LinkClickedC]>;
export type NonEmailSendActivityU = DocumentDownloaded | DocumentViewed | OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | EmailOpened | EmailLinkClicked | LinkClicked;
export const NonEmailSendActivityCU: NonEmailSendActivityCU = t.union([documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC]) satisfies t.Type<NonEmailSendActivityU, unknown>;

export type NonEmailSendActivityMap<A> = { [K in NonEmailSendActivityName]: A };


export type ActivitiesC = t.TypeC<{
  viewedOffering: t.NumberC,
  viewedRoadshow: ReadonlyMapFromEntriesC<t.NumberC, t.NumberC>,
  downloadedDocument: ReadonlyMapFromEntriesC<t.NumberC, t.NumberC>,
  viewedDocument: t.NumberC,
  submittedContactForm: t.NumberC,
  receivedEmail: t.NumberC,
  openedEmail: t.NumberC,
  clickedEmail: t.NumberC,
  didAnythingOtherThanEmailAction: t.NumberC,
  viewedRfp: t.NumberC,
  clickedLink: t.NumberC
}>;
export type Activities = {
  viewedOffering: number,
  viewedRoadshow: ReadonlyMap<number, number>,
  downloadedDocument: ReadonlyMap<number, number>,
  viewedDocument: number,
  submittedContactForm: number,
  receivedEmail: number,
  openedEmail: number,
  clickedEmail: number,
  didAnythingOtherThanEmailAction: number,
  viewedRfp: number,
  clickedLink: number
};
export const activitiesC: ActivitiesC = t.type({
  viewedOffering: t.number,
  viewedRoadshow: readonlyMapFromEntries(t.number, numberOrd, t.number),
  downloadedDocument: readonlyMapFromEntries(t.number, numberOrd, t.number),
  viewedDocument: t.number,
  submittedContactForm: t.number,
  receivedEmail: t.number,
  openedEmail: t.number,
  clickedEmail: t.number,
  didAnythingOtherThanEmailAction: t.number,
  viewedRfp: t.number,
  clickedLink: t.number
}) satisfies t.Type<Activities, unknown>;


export type TabCountsC = t.TypeC<{
  all: imported9_TabCountC<imported0_EmptyObjectC>,
  site: imported10_TabCountC<SiteActivityCU>,
  email: imported11_TabCountC<EmailActivityCU>,
  document: imported12_TabCountC<DocumentActivityCU>
}>;
export type TabCounts = {
  all: imported9_TabCount<imported0_EmptyObject>,
  site: imported10_TabCount<SiteActivityU>,
  email: imported11_TabCount<EmailActivityU>,
  document: imported12_TabCount<DocumentActivityU>
};
export const tabCountsC: TabCountsC = t.type({
  all: imported9_tabCountC(imported0_emptyObjectC),
  site: imported10_tabCountC(SiteActivityCU),
  email: imported11_tabCountC(EmailActivityCU),
  document: imported12_tabCountC(DocumentActivityCU)
}) satisfies t.Type<TabCounts, unknown>;


export type InvestorProfileInfoC = t.TypeC<{
  actor: imported6_ActorC,
  investorActivities: t.ReadonlyArrayC<InvestorActivityCU>,
  tabCounts: TabCountsC,
  holdings: t.ReadonlyArrayC<imported12_IpreoHoldingsC>
}>;
export type InvestorProfileInfo = {
  actor: imported6_Actor,
  investorActivities: ReadonlyArray<InvestorActivityU>,
  tabCounts: TabCounts,
  holdings: ReadonlyArray<imported12_IpreoHoldings>
};
export const investorProfileInfoC: InvestorProfileInfoC = t.type({
  actor: imported6_actorC,
  investorActivities: t.readonlyArray(InvestorActivityCU),
  tabCounts: tabCountsC,
  holdings: t.readonlyArray(imported12_ipreoHoldingsC)
}) satisfies t.Type<InvestorProfileInfo, unknown>;


export type InvestorActivityRowC = t.TypeC<{
  actor: imported7_ActorC,
  activities: ActivitiesC,
  lastActive: LocalDateTimeFromIsoStringC
}>;
export type InvestorActivityRow = {
  actor: imported7_Actor,
  activities: Activities,
  lastActive: LocalDateTime
};
export const investorActivityRowC: InvestorActivityRowC = t.type({
  actor: imported7_actorC,
  activities: activitiesC,
  lastActive: LocalDateTimeFromIsoStringC
}) satisfies t.Type<InvestorActivityRow, unknown>;


export type InvestorActivityTableC = t.TypeC<{
  investorActivityRows: t.ReadonlyArrayC<InvestorActivityRowC>,
  documents: t.ReadonlyArrayC<imported265_WithIdC<imported20_DocumentWithCategoryC>>
}>;
export type InvestorActivityTable = {
  investorActivityRows: ReadonlyArray<InvestorActivityRow>,
  documents: ReadonlyArray<imported265_WithId<imported20_DocumentWithCategory>>
};
export const investorActivityTableC: InvestorActivityTableC = t.type({
  investorActivityRows: t.readonlyArray(investorActivityRowC),
  documents: t.readonlyArray(imported265_withIdC(imported20_documentWithCategoryC))
}) satisfies t.Type<InvestorActivityTable, unknown>;


